import {
  REMOVE_USER_TOKEN_DATA,
  SET_SELF_USER_DATA,
  SET_USER_TOKEN_DATA,
  REMOVE_USER_DATA,
  SET_BATTERY_USER,
} from "../actions/types";

const initialState = {
  tokenData: null,
  userData: {},
  batteryUser: null,
};

const tokenReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BATTERY_USER: {
      return {
        ...state,
        batteryUser: action.data,
      };
    }
    case SET_USER_TOKEN_DATA: {
      return {
        ...state,
        tokenData: action.data,
      };
    }
    case SET_SELF_USER_DATA: {
      return {
        ...state,
        userData: action.data,
      };
    }
    case REMOVE_USER_TOKEN_DATA: {
      return {
        ...state,
        tokenData: null,
      };
    }
    case REMOVE_USER_DATA: {
      return {
        ...state,
        userData: {},
      };
    }
    default:
      return state;
  }
};

export default tokenReducer;
